import React, {
  // useState 
} from "react"




export const GT = () => {
  return (
    <>
     
        <div className="flex-grow pt-[6.6rem]">
          <div className=" ">This is GT</div>
        </div>
      





    </>
  )
}